import { takeEvery } from 'redux-saga';
import { all, call, put, select, take } from 'redux-saga/effects';
import { getJSON, postJSON } from '../util';


export function* init(upc) {
    const [ api, params ] = yield all([
        select(state => state.api.host),
        select(state => state.api.params),
    ]);
    const [ teeup, price ] = yield [
        call(getJSON, `/api/product/description/${upc}/teeup`),
        call(getJSON, `${api}/commerce/price/${upc}`, params),
    ];
    yield [
        put({ type: 'product:teeup', payload: teeup }),
        put({ type: 'product:price', payload: price }),
        put({ type: 'product:type', payload: 'Report' }),
    ];
}

export function* submit(action) {
    const { payload } = action;
    const [ upc, user ] = yield [
        select(state => state.product.teeup.code),
        select(state => state.user),
    ];

    if (!user.logged_in) {
        yield [
            put({
                type: 'route:to',
                payload: 'login',
            }),
            take('user:logged-in'),
        ];
    }

    yield put({ type: 'product:submitting', payload: true });

    let birthDate, forecastDate;
    // handle select fields
    if (!/^\d{4}[-]\d{2}[-]\d{2}$/.test(payload[3].value)) {
        birthDate = `${payload[5].value}-${payload[3].value}-${payload[4].value}`;
        forecastDate = `${payload[7].value}-${payload[6].value}-01`;
    } else {
        birthDate = payload[3].value;
        forecastDate = `${payload[4].value}-01`;
    }

    const inputs = {
        birth_name: payload[0].value,
        name: payload[1].value,
        gender: payload[2].value,
        birth_date: birthDate,
        forecast_date: forecastDate,
    };

    try {
        const order = yield call(postJSON, `/api/product/submit/${upc}`, JSON.stringify(inputs));
        yield put({ type: 'location:href', payload: order.forwarding_url });
    } catch(e) {
        yield [
            put({ type: 'product:error', payload: 'sorry, an error occurred' }),
            put({ type: 'product:submitting', payload: false }),
        ];
    }
}

export function* root() {
    const { payload: upc } = yield take('forecast:init');
    yield call(init, upc);
    yield* takeEvery('product:submit', submit);
}



// WEBPACK FOOTER //
// ./app/sagas/forecast.js